/**
 * Created by tomers on 4/14/2015.
 */
define(function (require) {
    "use strict";

    //require regions fold
    var LE = require("app");

    //utilities
    var headerTabsEnum = require("user-management-assets/data/headerTabs.json");

    var HeaderTabsController = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        HeaderTabsController = (function () {

            var initialize = function(options) {
                if (this.initialized) {
                    return HeaderTabsController;
                }

                this.vent = LEUserManagement.media.channel(LEUserManagement.channels.HEADER_TABS).vent;
                this.headerTabsArr = _initHeaderTabsArr.call(this);

                this.initialized = true;
                return HeaderTabsController;
            };

            var getHeaderTabsArr = function() {
                return this.headerTabsArr;
            };

            var selectTab = function(selectedTabId) {
                switch(selectedTabId) {
                    case headerTabsEnum.SKILLS:
                        LEUserManagement.router.navigate("skills");
                        break;
                    case headerTabsEnum.USERS:
                        LEUserManagement.router.navigate("peopleList");
                        break;
                    case headerTabsEnum.AGENT_GROUPS:
                        LEUserManagement.router.navigate("agentGroups");
                        break;
                    case headerTabsEnum.PROFILES:
                        LEUserManagement.router.navigate("profiles");
                        break;
                    default:
                        break;
                }
            };


            var _initHeaderTabsArr = function() {
                return _.map(headerTabsEnum, function(tab) {
                    return {
                        id: tab,
                        name: LE.translator.translate("LEUserManagement.headerTabs."+tab+".name")
                    };
                });
            };


            return {
                initialize: initialize,
                getHeaderTabsArr: getHeaderTabsArr,
                selectTab: selectTab
            };
        })();

    }

    LE.module("LEUserManagement", moduleDefinition);

    HeaderTabsController.HeaderTabsEnum = headerTabsEnum;
    return HeaderTabsController;

});